import gql from 'graphql-tag';

export default function (params) {
    return gql`
    mutation{
        unassignPCMaster(
        id: "${params.id}",
        ){
            errors
        }
    }
    `;
}
